import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { PfeEmptyRoutingComponent } from './components/pfe-empty-routing/pfe-empty-routing.component';
import { PFERouteGeneratorService } from './services/pfe-routing/route-generator.service';

const routes: Routes = [
  {
    path: '',
    data: {
      pfeParent: true,
    },
    children: [
      {
        // Needed to make the angular compiler happy
        component: PfeEmptyRoutingComponent,
        path: '**',
        canActivate: [
          (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(PFERouteGeneratorService).canActivate(route, state),
        ],
      },
    ],
  },
];

@NgModule({
  declarations: [PfeEmptyRoutingComponent],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NgxPfeRoutingModule {}
